// extracted by mini-css-extract-plugin
module.exports = {"format":"feedback_format__2GyqC","format_button":"feedback_format_button__3C3e4"};